import React from "react";
import {
  Box,
  TextField,
  Button,
  Popover,
  Autocomplete,
  ButtonGroup,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const OrderFilters = ({
  isMobile,
  searchOrderCode,
  onSearchChange,
  anchorEl,
  onOpenFilters,
  onCloseFilters,
  id,
  openPopover,
  products,
  filterProduct,
  setFilterProduct,
  filterStartDate,
  setFilterStartDate,
  filterEndDate,
  setFilterEndDate,
  customers,
  filterCustomer,
  setFilterCustomer,
  customerSearch,
  setCustomerSearch,
  hasMoreCustomers,
  isFetchingCustomers,
  fetchCustomers,
  customerPage,
  statusOptions,
  filterStatus,
  setFilterStatus,
  onDateRangeChange,
}) => {
  const renderFilters = () => (
    <>
      <ButtonGroup variant="outlined" aria-label="Date range filter">
        <Button onClick={() => onDateRangeChange("today")}>Hôm nay</Button>
        <Button onClick={() => onDateRangeChange("thisWeek")}>Tuần này</Button>
        <Button onClick={() => onDateRangeChange("thisMonth")}>Tháng này</Button>
      </ButtonGroup>

      <Autocomplete
        options={[{ _id: "", name: "Tất cả" }, ...products]}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        value={products.find((p) => p._id === filterProduct) || {
          _id: "",
          name: "Tất cả",
        }}
        onChange={(event, newValue) => {
          setFilterProduct(newValue ? newValue._id : "");
        }}
        renderInput={(params) => <TextField {...params} label="Sản phẩm" variant="outlined" />}
      />

      <DatePicker
        label="Ngày bắt đầu"
        format="dd/MM/yyyy"
        value={filterStartDate ? new Date(filterStartDate) : null}
        onChange={(newValue) => {
          if (newValue) {
            newValue.setHours(0, 0, 0, 0);
            setFilterStartDate(newValue.toISOString());
          } else {
            setFilterStartDate("");
          }
        }}
        renderInput={(params) => <TextField {...params} variant="outlined" />}
        dayOfWeekFormatter={(day) => {
          return ["CN", "T2", "T3", "T4", "T5", "T6", "T7"][
              day.getDay()
          ];
        }}
      />

      <DatePicker
        label="Ngày kết thúc"
        format="dd/MM/yyyy"
        value={filterEndDate ? new Date(filterEndDate) : null}
        onChange={(newValue) => {
          if (newValue) {
            newValue.setHours(23, 59, 59, 999);
            setFilterEndDate(newValue.toISOString());
          } else {
            setFilterEndDate("");
          }
        }}
        renderInput={(params) => <TextField {...params} variant="outlined" />}
        dayOfWeekFormatter={(day) => {
          return ["CN", "T2", "T3", "T4", "T5", "T6", "T7"][
              day.getDay()
          ];
        }}
      />

      <Autocomplete
        options={[{ _id: "", name: "Tất cả" }, ...customers]}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        value={customers.find((c) => c._id === filterCustomer) || {
          _id: "",
          name: "Tất cả",
        }}
        onInputChange={(event, newInputValue) => setCustomerSearch(newInputValue)}
        ListboxProps={{
          onScroll: (event) => {
            const listboxNode = event.currentTarget;
            if (
              listboxNode.scrollTop + listboxNode.clientHeight ===
                listboxNode.scrollHeight &&
              hasMoreCustomers &&
              !isFetchingCustomers
            ) {
              fetchCustomers(customerPage, customerSearch);
            }
          },
        }}
        onChange={(event, newValue) => setFilterCustomer(newValue ? newValue._id : "")}
        renderInput={(params) => <TextField {...params} label="Khách hàng" variant="outlined" />}
      />

      <Autocomplete
        options={statusOptions}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={statusOptions.find((option) => option.value === filterStatus) || null}
        onChange={(event, newValue) => setFilterStatus(newValue ? newValue.value : "")}
        renderInput={(params) => <TextField {...params} label="Trạng thái" variant="outlined" />}
      />
    </>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: 2,
        mb: 2,
        mt: 1,
        position: isMobile ? "sticky" : "static",
        top: isMobile ? "56px" : "auto",
        zIndex: 10,
        backgroundColor: "background.paper",
        p: 0,
        borderBottom: isMobile ? "1px solid #ddd" : "none",
      }}
    >
      <TextField
        label="Tìm kiếm theo mã ĐH"
        variant="outlined"
        value={searchOrderCode}
        onChange={onSearchChange}
        fullWidth
      />

      {isMobile ? (
        <>
          <Box sx={{ alignSelf: "flex-start" }}>
            <Button variant="text" onClick={onOpenFilters}>
              Lọc thêm
            </Button>
          </Box>
          <Popover
            id={id}
            open={openPopover}
            anchorEl={anchorEl}
            onClose={onCloseFilters}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <Box
              sx={{
                p: 2,
                minWidth: 250,
                maxWidth: 300,
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              {renderFilters()}
            </Box>
          </Popover>
        </>
      ) : (
        renderFilters()
      )}
    </Box>
  );
};

export default OrderFilters;
